import React, {useEffect} from 'react';
import SeoTags from '../components/SeoTags';
import {withUserGetServerSideProps} from '../util/util';
import wrapper from '../store/store';
import {useRouter} from 'next/router';
import AuthSection from '../components/AuthSection';
import {useAuth} from '../util/auth';
import {fetchMeta} from '../util/pages';
import {cn} from '@/lib/utils';
import {Typography} from '@/components/ui/typography';

function PasswordForgotten() {
    const router = useRouter();
    const {email, hash} = router.query;
    const auth = useAuth();


    useEffect(() => {
        if (email && hash && !auth.isAuthenticated) {
            auth.signin({username: email, hash}).catch((err) => {
                console.error(err);
            });
        }
    }, [email, hash, auth]);

    const showResetPasswordForm = (email && hash);
    const showForgotPasswordForm = (!email && !hash);

    return <>
        <SeoTags config={{
            title: 'Password reset'
        }} />

        <div className={cn("container flex flex-col items-center justify-center mt-36")}>
            {showResetPasswordForm || showForgotPasswordForm ? (
                <AuthSection
                    color="white"
                    size="large"
                    backgroundImage=""
                    backgroundImageOpacity={1}
                    buttonColor="primary"
                    buttonInverted={false}
                    type={showResetPasswordForm ? 'resetpass' : 'forgotpass'}
                    afterAuthPath={'/user/dashboard'}
                />
            ) : (
                <div className="flex flex-col text-center gap-4">
                    <Typography variant="h1" asChild>
                        <h1>Almost there!</h1>
                    </Typography>
                    <Typography variant="large">
                        We emailed a password reset link to <strong>{email}</strong>.
                    </Typography>
                    <Typography variant="muted">
                        Please check the e-mail to continue on Casehub.
                    </Typography>
                </div>
            )}
        </div>
    </>
}


export const getServerSideProps = wrapper.getServerSideProps(withUserGetServerSideProps(async (ctx) => {
    const content = await fetchMeta();
    return { props: {content} }
}));


export default PasswordForgotten;
